import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  formatBytes,
  getFileExtension,
  isNumeric,
  saveFile,
  downloadMultipleFiles,
} from "../Utils";
import OutputDimentionScale from "../merge_images/OutputDimentionScale";

import ImageViewerView from "../image_viewer/ImageViewerView";
import { splitImage } from "../ImageHelper/ImageRenderer";

function SplitImageListImagesScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //image info
  const [imageInfo, setImageInfo] = useState({
    state: AppState.NONE,
    thumbnail: null,
    message: "",
    mimeType: "image/jpeg",
    name: "",
    file: null, //selected file
    size: 0, //in bytes;
  });
  //output settings
  const [outputSettings, setOutputSettings] = useState({
    type: {
      popupShowing: false,
      export_as: ".jpg",
      mimetype: "image/jpeg",
    },
    margin: 5, //in pixels
    outputDimension: {
      outputDimension: OutputDimentionScale.AUTO,
      width: 100,
      height: 100,
      popupShowing: false,
    },
    rowCount: 1,
    colCount: 2,
  });
  //is splitting
  const [isSplitting, setIsSplitting] = useState(false);

  //show image preview
  const [showImagePreview, setShowImagePreview] = useState({
    preview: false,
    file: null,
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //generate thumbnail
      generateThumbnail();

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  //generate thumbnails
  const generateThumbnail = () => {
    //check
    if (selectedFiles.length > 0) {
      //selected file
      const selectedFile = selectedFiles[0];
      //set image
      setImageInfo({
        ...imageInfo,
        state: AppState.LOADED,
        thumbnail: URL.createObjectURL(selectedFile),
        message: "",
        mimeType: selectedFile.type,
        name: selectedFile.name,
        file: selectedFile, //selected file
        size: selectedFile.size, //in bytes
      });
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setImageInfo({
      thumbnail: null,
      message: "",
      mimeType: "image/jpeg",
      name: "",
      file: null, //selected file
      size: 0, //in bytes;
    });
    setStartProcessingFiles(false);
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //show preview
          setShowImagePreview({
            ...showImagePreview,
            preview: true,
            file: item,
          });
        }}
      >
        {/* Flex container left image right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  imageInfo.thumbnail != null
                    ? imageInfo.thumbnail
                    : "./images/file_icon.png"
                }
                alt="image_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size: {formatBytes(item.size)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  imageInfo.state === AppState.PROCESSED
                    ? "text-success"
                    : "bg-danger text-white"
                }`}
              >
                {imageInfo.state === AppState.PROCESSED
                  ? "SPLITTED"
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Page Count */}
            <div className="px-2 fs-6 text-body-secondary">
              {`Index: ${index + 1}`}
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                imageInfo.message !== "" ? "" : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {imageInfo.message}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          <div
            className="position-absolute justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-sm-3 ms-2 ${
                imageInfo.state === AppState.PROCESSING ? "" : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                imageInfo.state === AppState.LOADED ||
                imageInfo.state === AppState.NONE
                  ? ""
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                  //remove thumbnails
                  setImageInfo({
                    thumbnail: null,
                    message: "",
                    mimeType: "image/jpeg",
                    name: "",
                    file: null, //selected file
                    size: 0, //in bytes;
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* show image preview */}
      {/* page main content */}
      {showImagePreview.preview ? (
        <ImageViewerView
          title={
            showImagePreview.file === null ? "" : showImagePreview.file.name
          }
          onClose={() => {
            //set preview
            setShowImagePreview({
              ...showImagePreview,
              preview: false,
              file: null,
            });
          }}
          file={showImagePreview.file}
        ></ImageViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Split Image"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* Additional settings */}
              <div
                className="ms-4 "
                style={{
                  width: "calc(100% - 48px)",
                }}
              >
                {/* Additional settings */}
                <div className="w-100 mt-4 border-bottom pb-3">
                  <label className="fs-4">Configurations:</label>
                </div>

                {/* Output image file type */}
                <div className="d-flex mt-2 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Export as:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenuImageType"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setOutputSettings({
                          ...outputSettings,
                          type: {
                            ...outputSettings.type,
                            popupShowing:
                              outputSettings.type.popupShowing === true
                                ? false
                                : true,
                          },
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {outputSettings.type.export_as}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        outputSettings.type.popupShowing === true ? "show" : ""
                      }`}
                      aria-labelledby="dropdownMenuImageType"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".jpg",
                              mimetype: "image/jpg",
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .jpg
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".jpeg",
                              mimetype: "image/jpeg",
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .jpeg
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".png",
                              mimetype: "image/png",
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .png
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".bmp",
                              mimetype: "image/bmp",
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .bmp
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".webp",
                              mimetype: "image/webp",
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .webp
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".svg",
                              mimetype: "image/svg+xml",
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .svg
                      </button>
                    </div>
                  </div>
                </div>

                {/* Row Count */}
                <div
                  className="d-flex mt-2 my-auto text-center"
                  style={{ height: "48px", maxHeight: "48px" }}
                >
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary py-3">Rows:</label>
                  {/*Input */}
                  <input
                    type="number"
                    className="form-control mt-2 ms-2"
                    id="rows"
                    placeholder="1, 2, 3"
                    onChange={(e) => {
                      //set rowcount
                      setOutputSettings({
                        ...outputSettings,
                        rowCount: isNumeric(e.target.value)
                          ? e.target.value
                          : outputSettings.rowCount,
                      });
                    }}
                    value={outputSettings.rowCount}
                    style={{ width: "100px" }}
                  />
                </div>

                {/* Col Count */}
                <div
                  className="d-flex mt-2 my-auto text-center"
                  style={{ height: "48px", maxHeight: "48px" }}
                >
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary py-3">
                    Columns:
                  </label>
                  {/*Input */}
                  <input
                    type="number"
                    className="form-control mt-2 ms-2"
                    id="cols"
                    placeholder="1, 2, 3"
                    onChange={(e) => {
                      //set colcount
                      setOutputSettings({
                        ...outputSettings,
                        colCount: isNumeric(e.target.value)
                          ? e.target.value
                          : outputSettings.colCount,
                      });
                    }}
                    value={outputSettings.colCount}
                    style={{ width: "100px" }}
                  />
                </div>

                {/* margin */}
                <div
                  className="d-flex mt-2 my-auto text-center"
                  style={{ height: "48px", maxHeight: "48px" }}
                >
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary py-3">
                    Margin (in px):
                  </label>
                  {/*Input */}
                  <input
                    type="number"
                    className="form-control mt-2 ms-2"
                    id="margin"
                    placeholder="5 px"
                    onChange={(e) => {
                      //set margin
                      setOutputSettings({
                        ...outputSettings,
                        margin: e.target.value,
                      });
                    }}
                    value={outputSettings.margin}
                    style={{ width: "100px" }}
                  />
                </div>

                {/* Output Size label  */}
                <div className="w-100 mt-5 border-bottom pb-3">
                  <label className="fs-4">Output Size:</label>
                </div>

                {/* Output Dimension */}
                <div className="d-flex mt-4 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Size:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenuOutputDimensionScale"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setOutputSettings({
                          ...outputSettings,
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            popupShowing:
                              outputSettings.outputDimension.popupShowing ===
                              true
                                ? false
                                : true,
                          },
                          type: {
                            ...outputSettings.type,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {outputSettings.outputDimension.outputDimension}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        outputSettings.outputDimension.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenuOutputDimensionScale"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                              outputDimension: OutputDimentionScale.AUTO,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {OutputDimentionScale.AUTO}
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                              outputDimension: OutputDimentionScale.FIXED_SIZE,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {OutputDimentionScale.FIXED_SIZE}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Output Size */}
                <div
                  className={`bg-light ms-2 mt-2 rounded-2 p-1 ${outputSettings.outputDimension.outputDimension === OutputDimentionScale.FIXED_SIZE ? "" : "d-none"}`}
                >
                  {/* Width */}
                  <div
                    className="d-flex my-auto text-center"
                    style={{ height: "48px", maxHeight: "48px" }}
                  >
                    {/* Label */}
                    <label
                      className="fs-6 me-2 text-secondary py-3"
                      style={{ minWidth: "55px" }}
                    >
                      W (px):
                    </label>
                    {/*Input */}
                    <input
                      type="number"
                      className="form-control mt-2 ms-2"
                      id="output_width"
                      placeholder="0 px"
                      value={outputSettings.outputDimension.width}
                      onChange={(e) => {
                        //set width
                        setOutputSettings({
                          ...outputSettings,
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            width: e.target.value,
                          },
                        });
                      }}
                      style={{ width: "80px" }}
                    />
                  </div>

                  {/* Height */}
                  <div
                    className="d-flex mt-2 my-auto text-center"
                    style={{ height: "48px", maxHeight: "48px" }}
                  >
                    {/* Label */}
                    <label
                      className="fs-6 me-2 text-secondary py-3"
                      style={{ minWidth: "55px" }}
                    >
                      H (px):
                    </label>
                    {/*Input */}
                    <input
                      type="number"
                      className="form-control mt-2 ms-2"
                      id="output_height"
                      placeholder="0 px"
                      value={outputSettings.outputDimension.height}
                      onChange={(e) => {
                        //set height
                        setOutputSettings({
                          ...outputSettings,
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            height: e.target.value,
                          },
                        });
                      }}
                      style={{ width: "80px" }}
                    />
                  </div>
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isSplitting ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                }}
                type="button"
                onClick={async (e) => {
                  //hide all popups
                  setOutputSettings({
                    ...outputSettings,
                    type: { ...outputSettings.type, popupShowing: false },
                    outputDimension: {
                      ...outputSettings.outputDimension,
                      popupShowing: false,
                    },
                  });
                  //set
                  setIsSplitting(true);
                  //set
                  setImageInfo({
                    ...imageInfo,
                    state: AppState.PROCESSING,
                    message: `Processing image...`,
                  });

                  //check
                  if (selectedFiles.length > 0) {
                    //split image
                    await splitImage(
                      selectedFiles[0],
                      {
                        type: outputSettings.type.mimetype,
                        rowCount: Number(Math.max(1, outputSettings.rowCount)),
                        colCount: Number(Math.max(1, outputSettings.colCount)),
                        margin: Number(outputSettings.margin),
                        outputDimensionType:
                          outputSettings.outputDimension.outputDimension,
                        outputDimension: {
                          width: Number(outputSettings.outputDimension.width),
                          height: Number(outputSettings.outputDimension.height),
                        },
                      },
                      async (splitImages) => {
                        //set
                        //set blob
                        setImageInfo({
                          ...imageInfo,
                          state: AppState.PROCESSED,
                          message: `Successfully splitted image into parts. Generated images will be downloaded automatically on your device as .zip.`,
                        });

                        //get zipped array
                        const blob = await downloadMultipleFiles(
                          splitImages,
                          "split_image",
                          "STORE",
                        );

                        //save file
                        saveFile(blob, `split_image.zip`);
                      },
                    );
                  }
                  //reset
                  setIsSplitting(false);
                }}
              >
                SPLIT
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SplitImageListImagesScreen;
